import createCollection from './createCollection';
import updateCollection from './updateCollection';
import getCollections from './getCollections';
import archiveCollections from './archiveCollections';
import getFilters from '../filters/getFilters';
import sendNotifications from '../notifications/send';

import combineActions from '../../utils/combineActions';

export default combineActions({
    createCollection,
    updateCollection,
    getCollections,
    archiveCollections,
    getFilters,
    sendNotifications,
});
